import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

import { Window } from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import "./TenderingManager.scss";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
import $, { event } from "jquery";
import { Link } from "react-router-dom";
import * as TMService from "./TenderingManager.service";
import CarrierContactInfo from "./CarrierContactInfo";

const dataState = {
  sort: [],
  take: 10,
  skip: 0,
};

class CarrierSelTenderingMgr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyData: [],
      currencySelected: null,
      scacCurrencyArray: [],
      carrierSCACArray: [],
      carrierSCACNQArray: [],
      carrierSCACData: [],
      carrierSCACNQData: [],
      expandedCarrierChildsSelected: [],
      max_resp_dur: "",
      blocking: true,
      dataState: dataState,
    };
  }

  async getCarrierData() {
    // this.setState({ blocking: true });

    let props = {};
    let inputObj1 = {};
    let inputObj = {};
    inputObj1["shipFrom"] = this.props.shipFrom;
    inputObj1["shipTo"] = this.props.shipTo;
    inputObj1["servType"] = this.props.serviceType?.value;
    inputObj1["modeOfTransport"] = this.props.transportationValue?.value;
    let InputJSONString = JSON.stringify(inputObj1);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;

    inputObj["Activity"] = "PRE_QUAL_LIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const responseArray = await GatewayGet(props, props.input);

    // this.setState({ blocking: false });
  
    for (var i = 0; i < responseArray.length; i++) {
      if (responseArray[i].qualified == "Y") {
        var isAvailable = false;
        for (var j = 0; j < this.state.carrierSCACArray.length; j++) {
          if (this.state.carrierSCACArray[j].scacd == responseArray[i].scacd)
            isAvailable = true;
        }

        if (!isAvailable) {
          var obj = {};
          obj["selected"] = false;
          obj["scacd"] = responseArray[i].scacd;
          obj["carrierId"] = responseArray[i].carrierId;
          if (obj["carrierId"] != undefined && obj["carrierId"] != null) {
            obj["carrierId"] = obj["carrierId"].replace("CA_", "");
          }
          this.state.carrierSCACArray.push(obj);
        }
        // this.setState({carrierSCACData : this.state.carrierSCACArray})
      } else {
        var isAvailable = false;
        for (var j = 0; j < this.state.carrierSCACNQArray.length; j++) {
          if (this.state.carrierSCACNQArray[j].scacd == responseArray[i].scacd)
            isAvailable = true;
        }

        if (!isAvailable) {
          var obj = {};
          obj["selected"] = false;
          obj["scacd"] = responseArray[i].scacd;
          obj["carrierId"] = responseArray[i].carrierId;
          if (obj["carrierId"] != undefined && obj["carrierId"] != null) {
            obj["carrierId"] = obj["carrierId"].replace("CA_", "");
          }
          this.state.carrierSCACNQArray.push(obj);
        }
      }
      this.setState({ blocking: false });
    }
   
    this.setState({
      carrierSCACNQData: this.state.carrierSCACNQArray,
      carrierSCACData: this.state.carrierSCACArray,
    });
  }

  async getCarrirSCACInfo(dataItem) {
    

    var carrierContactChildDataFiltered = [];
    let props = {};
    let inputObj = {};
    let InputJSONString = "";

    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_CARRIER_INFO";
    inputObj["Input"] = "";
    props.input = inputObj;

    const carrierInfoResponse = await GatewayGet(props, props.input);

   

    this.setState({ carrierInfoArray: carrierInfoResponse });
  }

  async getCurrencyData() {
   
debugger;
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SCAC_CURR";
    inputObj["Input"] = "";
    props.input = inputObj;

    const currencyResponse = await GatewayGet(props, props.input);
   console.log(currencyResponse)

    // const currencyResponse = await TMService.getCurrencyData();
    this.setState({ scacCurrencyArray: currencyResponse });

    for (var i = 0; i < currencyResponse.length; i++) {
      var isAvailable = false;
      for (var j = 0; j < this.state.currencyData.length; j++) {
        if (
          this.state.currencyData[j].currency ==
          currencyResponse[i].currCode
        ) {
          isAvailable = true;
        }
      }
      if (!isAvailable) {
        var currencyObj = {};
        currencyObj["currency"] =currencyResponse[i].currCode;
        this.state.currencyData.push(currencyObj);
      }
    }

    const defaultCurrency = this.state.currencyData.find(
      (c) => c["currency"] === "USD"
    );
    this.setState({ currencySelected: defaultCurrency });
  }

  expandChange = (event) => {
    var filteredData = [];
    const isExpanded =
      event.dataItem.expanded === undefined
        ? event.dataItem.aggregates
        : event.dataItem.expanded;
    event.dataItem.expanded = !isExpanded;
    for (var i = 0; i < this.state.carrierInfoArray.length; i++) {
      if (this.state.carrierInfoArray[i].scacd == event.dataItem.scacd) {
        filteredData.push(this.state.carrierInfoArray[i]);
      }
    }
    event.dataItem.carierInfoData = filteredData;
    event.dataItem.changeExpandedCarrierChildsSelected =
    this.changeExpandedCarrierChildsSelected.bind(this);
    this.setState({ ...this.state });
  };

  componentDidMount() {
    this.setState({blocking : true})
    this.getCurrencyData();
    this.getCarrierData();
    this.getCarrirSCACInfo();
  }

  selectionChange(event) {
    const data = this.state.carrierSCACData.map((item) => {
      if (item.carrierId === event.dataItem.carrierId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.setState({ carrierSCACData: data });
  }

  headerSelectionChange(event) {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.carrierSCACData.map((item) => {
      item.selected = checked;
      return item;
    });
    this.setState({ carrierSCACData: data });
  }

  selectionChangeN(event) {
    const data = this.state.carrierSCACNQData.map((item) => {
      if (item.carrierId === event.dataItem.carrierId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.setState({ carrierSCACNQData: data });
  }

  headerSelectionChangeN(event) {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.carrierSCACNQData.map((item) => {
      item.selected = checked;
      return item;
    });
    this.setState({ carrierSCACNQData: data });
  }

  changeExpandedCarrierChildsSelected(data) {
    const parentIndex = this.state.expandedCarrierChildsSelected.findIndex(
      (d) => d["parent"]["carrierId"] === data["carrierId"]
    );

    if (parentIndex !== -1) {
      const tempState = this.state.expandedCarrierChildsSelected;
      tempState[parentIndex]["child"].push(data);
      this.setState({
        expandedCarrierChildsSelected: tempState,
      });
    } else {
      // if parentIndex -1
      const selectedChildScacInfo = {
        parent: { scacd: data["scacd"], carrierId: data["carrierId"] },
        child: [data],
      };
      this.setState({
        expandedCarrierChildsSelected: [
          ...this.state.expandedCarrierChildsSelected,
          selectedChildScacInfo,
        ],
      });
    }
  }

  async submitButtonClick() {
    // validation
    // 1st max_resp_dur if empty
    if (this.state.max_resp_dur === "") {
      toast.error("please enter Max Response Duration");
      return;
    }

    //validate max response duration
    // else{
    //   var regex = /^[0-9]+:\d+$/;
    //   var validInput = regex.test(this.state.max_resp_dur);
    //   //  var validInput = this.state.max_resp_dur.match(regex)
    //    if(validInput == false)
    //    {
    //     toast.error("please enter Max Response Duration in format 00:00");
    //     return;
    //    }
      

    // }
    if(this.state.max_resp_dur.indexOf(':') <= -1){
      this.state.max_resp_dur = this.state.max_resp_dur + ":" + "00";
    }

    // 2st if scac contacts (child table) more than 5 selected
    const scacContacts = this.state.expandedCarrierChildsSelected;
    for (let i = 0; i < scacContacts.length; i++) {
      if (scacContacts[i]["child"].length > 5) {
        toast.error(
          `You have selected more than 5 contacts for ${scacContacts[i]["parent"]["scacd"]} scac`,{theme:"colored"}
        );
        return;
      }
    }

    //  3ed if parent scac is selected then one of its child (contact) should be selected
    const completeCarrierSCACData = [
      ...this.state.carrierSCACNQData,
      ...this.state.carrierSCACData,
    ];
    const parent = completeCarrierSCACData
      .filter((c) => c["selected"] === true)
      .map((d) => d["carrierId"]);
    const child = scacContacts
      .filter((d) => d["child"].length > 0)
      .map((c) => c["parent"]["carrierId"]);

    for (let i = 0; i < parent.length; i++) {
      let childPresent = false;
      for (let j = 0; j < child.length; j++) {
        if (parent[i] === child[j]) {
          childPresent = true;
        }
      }
      if (!childPresent) {
        toast.error("Please select atleast one contact for SCAC/s selected",{theme:"colored"});
        return;
      }
    }

    for (let i = 0; i < child.length; i++) {
      let parentPresent = false;
      for (let j = 0; j < parent.length; j++) {
        if (child[i] === parent[j]) {
          parentPresent = true;
        }
      }
      if (!parentPresent) {
        toast.error("Please select atleast one SCAC for contact/s selected",{theme:"colored"});
        return;
      }
    }

    let childScacData = [];
    this.state.expandedCarrierChildsSelected.forEach((d) => {
      d["child"].forEach((c) => {
        childScacData.push(c);
      });
    });
    childScacData = childScacData.map((c) => ({
      EMAIL_ID: c["contactEmail"],
      CARRIER: c["carrierId"],
    }));

    let InputJSON = JSON.stringify({
      tor_id: this.props.tor_id,
      im_carrier_contact: childScacData,
    });

    this.setState({ blocking: true });

    // First api call
    let props = {};
    let inputObjs = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObjs["Activity"] = "FO_UPDATE_CONTACT_EMAIL";
    inputObjs["Input"] = InputJSON;
    props.input = inputObjs;
    const result = await GatewayGet(props, props.input);

    if (result["STATUS"] === "SUCCESS") {
      // Second api call
      this.foInitiateTendering();
    } else {
      this.setState({ blocking: false });
    }
  }

  async foInitiateTendering() {
    const completeCarrierSCACData = [
      ...this.state.carrierSCACNQData,
      ...this.state.carrierSCACData,
    ];

    let finalObj = completeCarrierSCACData
      .filter((d) => d["selected"] === true)
      .map((c) => ({ carrier: c["carrierId"] }));

    let InputJSON = JSON.stringify({
      tor_id: this.props.tor_id,
      max_resp_dur: this.state.max_resp_dur,
      currency: this.state.currencySelected["currency"],
      carrier: finalObj,
    });

    let props = {};
    let inputObjs = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObjs["Activity"] = "FO_INITIATE_TENDERING";
    inputObjs["Input"] = InputJSON;
    props.input = inputObjs;
    const result = await GatewayGet(props, props.input);

    if (result["STATUS"] === "SUCCESS") {
      toast.success("RFQ creation successful");
      this.setState({ blocking: false });
      this.props.closeCreateRequestScreen();
    } else {
      this.setState({ blocking: false });
      toast.error("RFQ creation Failed");
      this.props.closeCreateRequestScreen();
    }
  }

  cancelButtonClick() {
    this.props.closeCreateRequestScreen();
  }

  render() {
    return (
      <div className="TenderingManager">
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={
            <Circles
            color="#00BFFF"
            height="100"
            width="100"
            timeout="6000" //3 secs
          />
          }
        >
          <div>
            {/* <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            /> */}
            {/* Same as */}
            {/* <ToastContainer /> */}
          </div>
          {/* <MDBContainer fluid >
                <MDBRow>
                    <MDBCol sm="12" className="titleBox" ><label style={{ textAlign: "center" }}></label></MDBCol>
                </MDBRow>
                </MDBContainer>  */}
          <MDBContainer fluid className="cnt contentborderTab">
            <MDBRow>
              <MDBCol md="2">
                <label>
                  Max Response Duration<em>*</em>
                </label>
              </MDBCol>
              <MDBCol md="3">
                <input
                  type="text"
                  placeholder="hhhhh:mm"
                  max_resp_dur={this.state.max_resp_dur}
                  onChange={(event) =>
                    this.setState({ max_resp_dur: event.target.value })
                  }
                ></input>
              </MDBCol>
              <MDBCol md="2">
                <label>
                  Currency-1 <em>*</em>
                </label>
              </MDBCol>
              <MDBCol md="3">
                <DropDownList
                  data={this.state.currencyData}
                  dataItemKey={"currency"}
                  textField={"currency"}
                  value={this.state.currencySelected}
                  onChange={(event) =>
                    this.setState({ currencySelected: event.target.value })}
                ></DropDownList>
              </MDBCol>
            </MDBRow>
            <br></br>
            <MDBRow>
              <MDBCol md="1">
                {" "}
                <p>
                  <strong>Qualified Carrier</strong>
                </p>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              {/* Contracted  */}
              <Grid
               // data={this.state.carrierSCACData}
               data={process(this.state.carrierSCACData, this.state.dataState)}
                {...this.state.dataState}
                 onDataStateChange={(e) => {
                this.setState({ dataState: e.dataState });
                }}
                detail={CarrierContactInfo}
                expandField="expanded"
                onExpandChange={this.expandChange}
                ScrollMode="scrollable"
                style={{ width: "90vw", marginLeft: "10px" }}
                selectedField="selected"
                onSelectionChange={this.selectionChange.bind(this)}
                onHeaderSelectionChange={this.headerSelectionChange.bind(this)}
                pageable={true}
              >
                <GridColumn field="selected" width="80px"></GridColumn>
                <GridColumn title="Carrier SCAC" field="scacd"></GridColumn>
              </Grid>
            </MDBRow>
            <br></br>
            <br></br>
            <MDBRow>
              <MDBCol md="1">
                {" "}
                <p>
                  <strong>Non-Qualified Carrier</strong>
                </p>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              {/* not contracted */}
              <Grid
               // data={this.state.carrierSCACNQData}
                data={process(this.state.carrierSCACNQData, this.state.dataState)}
                {...this.state.dataState}
                 onDataStateChange={(e) => {
                this.setState({ dataState: e.dataState });
                }}
                detail={CarrierContactInfo}
                expandField="expanded"
                onExpandChange={this.expandChange}
                //ScrollMode="scrollable"
                style={{width: "90vw", marginLeft: "10px" }}
                selectedField="selected"
                onSelectionChange={this.selectionChangeN.bind(this)}
                onHeaderSelectionChange={this.headerSelectionChangeN.bind(this)}
                pageable={true}
              >
                <GridColumn field="selected" width="80px"></GridColumn>
                <GridColumn title="Carrier SCAC" field="scacd"></GridColumn>
              </Grid>
            </MDBRow>
            <br></br>
            <MDBRow>
              <button
                className="btn k-button k-button-icontext"
                onClick={this.submitButtonClick.bind(this)}
                style={{ margin: "10px", width: "80px" }}
              >
                Submit
              </button>
              <button
                className="btn k-button k-button-icontext"
                onClick={this.cancelButtonClick.bind(this)}
                style={{ margin: "10px", width: "80px" }}
              >
                Cancel
              </button>
            </MDBRow>
          </MDBContainer>
          <br></br>
        </BlockUi>
      </div>
    );
  }
}
export default CarrierSelTenderingMgr;
